module.exports = __webpack_public_path__ + "img/eyes_female_extra_round_mask.455c305c.png";